<template>
    <div class="swipeimage">
        <mt-swipe :auto="0" :speed="0">
            <mt-swipe-item v-for="attachment in attachments" :key="attachment.guid">
                <img class="swipe-img" preview="1" :src="fileUrl(attachment)" alt="">
            </mt-swipe-item>
        </mt-swipe>
    </div>
</template>

<script>
    export default {
        name: "SwipeImage",
        props: ['attachments'],
        data() {
          return {
              preview: null,
          }
        },
        mounted() {
            this.$preview.on('imageLoadComplete', () =>{
                this.preview = this.$preview.self;
            });
        },
        methods: {
            fileUrl(attachment) {
                return `${config.api_base_url}/applyAttachment?fileGuid=${attachment.fileName}`;
            },
        },
        beforeDestroy() {
            this.preview && this.preview.close();
        },
    }
</script>

<style scoped lang="scss">
    .swipeimage {
        height: 400px;
        width: 100%;
        .swipe-img {
            width: 100%;
            height: calc(100% - 20px);
            object-fit: contain;
            margin: 10px 0;
            border: 1px solid #ccc;
            background: #fff;
            background-image: linear-gradient(45deg, #ddd 25%, transparent 0, transparent 75%, #ddd 0), linear-gradient(45deg, #ddd 25%, transparent 0, transparent 75%, #ddd 0);
            background-position: 0 0, 12px 12px;background-size: 24px 24px;
        }
    }
</style>
<style>
    /*vue-photo-preview背景*/
    .pswp__bg {
        background-color: #fff!important;
        background-image: linear-gradient(45deg, #ddd 25%, transparent 0, transparent 75%, #ddd 0), linear-gradient(45deg, #ddd 25%, transparent 0, transparent 75%, #ddd 0) !important;
        background-position: 0 0, 12px 12px!important;
        background-size: 24px 24px !important;
    }
    /*vue-photo-preview进入图片背景*/
    .pswp__img--placeholder--blank {
        background: transparent!important;
    }
</style>